import {connect} from "react-redux";
import FastRules from "./FastRules";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {savePage} from "../../../globalState/object/actions";
import {
    getCheckInSelector,
    getCheckOutSelector,
    getRulesSelector,
    selectedCheckInSelector,
    selectedCheckOutSelector
} from "../../ObjectRules/selectors";

let mapStateToProps = (state) => {
    return {
        objectId: state.object.id,
        rules: getRulesSelector(state),
        checkIn: getCheckInSelector(state),
        checkOut: getCheckOutSelector(state),
        selectedCheckIn: selectedCheckInSelector(state),
        selectedCheckOut: selectedCheckOutSelector(state)
    }
};

export default compose(connect(mapStateToProps, {savePage}), withRouter)(FastRules);




